import { useState, useEffect, useContext } from 'react';

import { get_time_by_sec } from '../../../../util/utility';
import { SaleListContext } from '../SaleListContext';
import { SaleLabel } from '../label/SaleLabel';
import { SaleListItemInfo } from './info/SaleListItemInfo';
import { SaleListItemRibon } from './ribon/SaleListItemRibon';

export function SaleListItem(props: any) {
  const sale = props.sale;

  const setDetailSale = useContext(SaleListContext).setDetailSale;

  // 動画時間
  const [dispTime, setDispTime] = useState<string>('');


  useEffect(() => {
    // 動画時間
    if(sale?.movie_amount == 1 && sale?.movie_durations){
      // 単発動画
      setDispTime(get_time_by_sec(sale.movie_durations));
    } else if(sale?.movie_amount > 1) {
      // 動画セット
      setDispTime('動画セット');
    }
  }, [sale]);


  const onPress = () => {
    if(sale) {
      setDetailSale(sale);
    }
  }


  return (
    <>
    {sale &&
      <div
        style={{
          height: '100%',
          width: '100%',
          flex: 1,
          marginBottom: window.innerHeight * 0.03,
        }}
        onClick={onPress}
      >

        {/* サムネイル */}
        {sale.movie_thumb &&
          <div style={{position: 'relative', overflow: 'hidden'}}>
            <img
              src={`/images/sale/thumb/${sale.movie_thumb}?${Date.now()}`}
              className="img-thumbnail"
              style={{width: '100%', objectFit: 'cover'}}
              loading="lazy"
            />
            <SaleListItemRibon sale={sale} />

            {/* 動画時間 */}
            {dispTime &&
              <span style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                color: '#fff',
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                fontSize: '15px',
                fontWeight: '900',
                letterSpacing: '1.5px',
                pointerEvents: 'none',
                padding: '3px 7px',
                borderRadius: '10px',
              }}>{dispTime}</span>
            }

          </div>
        }

        {/* 情報 */}
        <div style={{padding: '3px 5px'}}>
          {/* 各種ラベル */}
          <SaleLabel sale={sale} />

          {/* 動画情報 */}
          <SaleListItemInfo sale={sale} />
        </div>

      </div>
    }
    </>
  );
}